import React, { memo } from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from 'ui-components/components/weight-input/messages';

import { UnitDisplayType, UnitDisplayTypePropType } from '../../../../enums/units/unit-display-type';

export const OuncesLabel = memo(({ unitDisplayType = UnitDisplayType.Abbreviated }) =>
  unitDisplayType === UnitDisplayType.AbbreviatedWithParentheses ? (
    <FormattedMessage {...messages.unitOuncesWithParentheses} />
  ) : (
    <FormattedMessage {...messages.unitOunces} />
  ),
);

OuncesLabel.propTypes = {
  unitDisplayType: UnitDisplayTypePropType,
};
